/**
 * Selects receipt-page success-alert copy from appsettings (via pageData DTO).
 * Presentation logic only — all wording lives in CrmMember:ReceiptAlerts.
 */

/** Plain "Pending Payment" (registration), not "Current - Pending Payment" (renewal). */
export function isRegistrationReceiptFlow(status) {
  if (!status) return false
  const s = status.toLowerCase().trim()
  return s.includes('pending payment') && !s.includes('current -')
}

const nonEmpty = (value) => (typeof value === 'string' && value.trim() ? value.trim() : null)

const pickAlert = (copy) => {
  const title = nonEmpty(copy?.title)
  const description = nonEmpty(copy?.description)
  if (!title || !description) return null
  return { title, description }
}

/**
 * @param {string|null|undefined} status - cached D365 membership status from member context
 * @param {object|null|undefined} receiptAlerts - from ReceiptDownloadPage DTO (renewal/registration/generic)
 * @returns {{ title: string, description: string } | null}
 */
export function getReceiptSuccessAlertProps(status, receiptAlerts) {
  if (!receiptAlerts) return null

  if (isRegistrationReceiptFlow(status)) return pickAlert(receiptAlerts.registration)
  if (!status) return pickAlert(receiptAlerts.generic)

  const s = status.toLowerCase().trim()
  if (s === 'current' || s.includes('current -')) return pickAlert(receiptAlerts.renewal)

  return pickAlert(receiptAlerts.generic)
}
